import { render } from "./CardCursos.vue?vue&type=template&id=7ba12b65"
import script from "./CardCursos.vue?vue&type=script&lang=js"
export * from "./CardCursos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__